import { createFileRoute } from "@tanstack/react-router";
import { BoardView } from "@/components/views";
import type { RouterAppContext } from "@/utils/custom-types";

export const Route = createFileRoute("/$workspaceId/boards/$channelId")({
	component: RouteComponent,
});

function RouteComponent() {
	const { workspaceId, channelId } = Route.useParams();
	const { session, currentWorkspace } =
		Route.useRouteContext() as RouterAppContext;
	
	return (
		<BoardView
			workspaceId={workspaceId}
			channelId={channelId}
			session={session}
			currentWorkspace={currentWorkspace}
		/>
	);
}
